import BackgroundImageLoader from '@components/imageModules/backgroundImageLoader'
import BackgroundImageV5 from '@components/imageModules/v5/backgroundImg_v5'
import Arrow1 from '@components/svgs/arrow1'
import Arrow2 from '@components/svgs/arrow2'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { classNames } from '@utils/genUtils'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { twMerge } from 'tailwind-merge'
export enum ProjectPositionEnums {
  LEFT = 'Left',
  RIGHT = 'Right',
  CENTER = 'Center'
}
interface Props {
  project: {
    bgPosition?: ProjectPositionEnums
    position?: ProjectPositionEnums
    image: IGatsbyImageDataObject
    title: string
    subTitle?: string
    subTitleClasses?: string
    desc: string
    mobileImage?: IGatsbyImageDataObject
  }
  hideArrow?: boolean
  headlineClasses?: string
}

function FullScreenProject(props: Props) {
  const { project: { image, title, position, bgPosition, desc, subTitle, subTitleClasses, mobileImage }, hideArrow = false, headlineClasses } = props

  const positionCss = getPositionClasses(position)
  const bgImageClasses = mobileImage ? 'hidden lg:block' : ''
  const getBgPosition = () => {
    switch (bgPosition) {
      case ProjectPositionEnums.RIGHT:
        return 'bg-left'
      case ProjectPositionEnums.CENTER:
        return 'bg-center'
      default:
        return 'bg-right'
    }
  }
  return (
    <BackgroundImageV5
      bgSrcClasses={getBgPosition()}
      // bgSrcClasses={position === ProjectPositionEnums.RIGHT ? 'bg-left' : 'bg-right'}
      bgImageClasses={twMerge('bgImageClasses relative h-[300px] md:h-[500px] lg:absolute lg:h-full', bgImageClasses)}
      innerDivClasses='xl:min-h-[950px]'
      gatsbyDataImg={image.gatsbyImageData}
      showBlurImage={true}>

      {mobileImage && <div className='relative z-10 col-span-2 col-start-2 lg:hidden'>
        <div className='relative '>
          <GatsbyImage image={mobileImage.gatsbyImageData} alt={title} />
        </div>
      </div>}

      <div className={classNames('relative flex flex-col items-start bg-white z-2 p-12 md:mx-auto md:max-w-[600px] lg:max-w-[400px] lg:absolute lg:shadow-2xl xl:p-20 xl:max-w-[600px]', positionCss)}>

        {subTitle && <div className={twMerge('relative text-xl font-bold text-[#BF8029]', subTitleClasses)}>
          {subTitle}
          {!hideArrow &&
            <div className='w-[60px] absolute top-[-49%] left-[91%] rotate-[175deg] -scale-x-100 lg:hidden'>
              <Arrow1 path='#000' />
            </div>}
        </div>}
        {/* {subTitle && <span className='my-4 text-2xl lg:mb-8 lg:text-3xl xl:text-4xl'>{subTitle}</span>} */}
        <h2 className={twMerge('mb-4 font-sentinel__SemiBoldItal lg:mb-8 text-4xl lg:text-5xl xl:text-7xl', headlineClasses)}>{title}</h2>

        <div className='mb-0 xl:text-lg' dangerouslySetInnerHTML={{ __html: desc }} />
      </div>

    </BackgroundImageV5>
  )
}

function getPositionClasses(position?: ProjectPositionEnums) {
  switch (position) {
    case ProjectPositionEnums.RIGHT:
      return 'lg:right-[5%] lg:top-[15%]'
    case ProjectPositionEnums.CENTER:
      return 'w-full lg:text-center lg:!max-w-[500px] lg:left-1/2 lg:-translate-x-1/2 lg:top-1/2 lg:-translate-y-1/2 xl:!max-w-[706px]'
    default:
      return 'lg:left-[5%] lg:top-[10%] xl:top-[15%]'
  }
}

export default FullScreenProject
